import React from 'react';
import Markdown from 'react-markdown';
import classNames from 'classnames';
import logoRounded from '../../../assets/images/logos/icon.svg';

interface Props {
    children: string | React.ReactElement;
    time?: string;
}

export const GptMessage = ({ children, time }: Props) => {
    return (
        <div className="w-full flex mb-4 justify-start">
            <img src={logoRounded} width={32} className="mr-2 mt-6" />
            <div
                className={classNames(
                    'max-w-[75%] rounded-2xl px-4 py-3 shadow-sm',
                    'bg-white text-slate-800 border border-slate-200 rounded-bl-sm'
                )}
            >
                <div className="whitespace-pre-wrap leading-relaxed prose prose-sm max-w-none">
                    {typeof children === 'string' ? (
                        <Markdown>{children}</Markdown>
                    ) : (
                        children
                    )}
                </div>

                {time && (
                    <div className="mt-1 text-xs text-slate-400">{time}</div>
                )}
            </div>
        </div>
    );
};
